import Vue from 'vue';

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { extend, localize, validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import en from "vee-validate/dist/locale/en.json";

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

localize({ en });

Object.keys(en.messages).forEach(key => extend(key, rules[key]) );

extend('between', {
    validate(value, { min, max }) {
        return Number(min) <= value && Number(max) >= value;
    },
    params: ['min', 'max'],
    message: 'The {_field_} must be between {min} and {max} years'
});

extend('us_phone_number', {
    validate: (value) =>  /^\+1\(\d{3}\)-\d{3}-\d{4}$/.test(value),
    message: (fieldName) => `The ${fieldName} must be valid ${fieldName.toLowerCase()}`
});

extend('zip', {
    validate: (value) => /^\d{5}(?:[-\s]\d{4})?$/.test(value),
    message: (fieldName) => `The ${fieldName} field format is invalid`
});

extend('credit_card', {
    validate(value) {
        const pattern16Digits = /^\d{4}-\d{4}-\d{4}-\d{4}$/;
        return pattern16Digits.test(value);
    },
    message: (fieldName) => `The ${fieldName} field format is invalid`
});

extend('cvv', {
    validate(value) {
        const pattern = /^\d{3,4}$/;
        return pattern.test(value);
    },
    message: (fieldName) => `The ${fieldName} field format is invalid`
});
